class CartPreview extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // only works on desktop
    if (window.innerWidth < 1024) return;
    this.insertContent();
  }

  insertContent() {
    this.innerHTML = `
      <h3>My Shopping Cart</h3>
      <p style="font-weight: 700; font-size: 16px;">PRODUCTS</p>
      <div class="divider"></div>
      <div class="cart-summary"></div>
      <div class="divider"></div>
      <div class="cart-subtotal-container">
        <p>Subtotal</p>
        <p class="cart-subtotal">$0</p>
      </div>
      <div class="action-button">
        <a href="/checkout">Checkout</a>
      </div>
    `;

    this.updateCartPreview();
  }

  async getCartData() {
    const response = await fetch("/cart.js");
    const data = await response.json();
    return data;
  }

  async updateCartPreview() {
    const cartSummary = this.querySelector(".cart-summary");
    const cartSubtotal = this.querySelector(".cart-subtotal");

    const cartData = await this.getCartData();
    // console.log(cartData);
    const { item_count, items, items_subtotal_price, total_price } = cartData;

    cartSubtotal.innerHTML = theme.Currency.formatMoney(items_subtotal_price);

    if (item_count > 0) {
      this.classList.remove("empty-cart");

      cartSummary.innerHTML = `
        ${items
          .map((item, index) => {
            const bundledWith = item?.properties["Bundled with"];
            const bundleId = item?.properties["Bundle ID"];

            let itemImage = item.image;

            const cartPreviewItem = $(
              `.cart-preview-items div[data-line_item_id="${item.id}"]`,
            );
            if (cartPreviewItem.length && cartPreviewItem.attr("data-image")) {
              itemImage = cartPreviewItem.attr("data-image");
            }

            // replacement filters link to the filters PDP (data-url from cart-preview.liquid)
            const itemUrl =
              item.product_id == 9021652795619
                ? "/products/prism-sentry-series-2026"
                : cartPreviewItem.attr("data-url") || item.url;
            const productTitle =
              item.product_id == 9021652795619
                ? "PRISM+ Sentry 2026"
                : item.product_title;

            let variantTitle = "";
            if (item.variant_title) {
              variantTitle = item.variant_title;

              if (item.product_id == 9021652795619) {
                variantTitle = variantTitle
                  .replace("Sentry Ultra Privacy Gate Lock", "For Glass/Privacy Gates (Ultra)")
                  .replace("Sentry Privacy Gate Lock", "For Glass/Privacy Gates")
                  .replace("Ultra", "(Ultra)");
              } else if (item.product_id == 9021652369635) {
                variantTitle = variantTitle
                  .replace("Sentry Ultra Gate Lock", "For Regular Gates (Ultra)")
                  .replace("Sentry Gate Lock", "For Regular Gates")
                  .replace("Ultra", "(Ultra)");
              } else if (item.product_id == 9021667672291) {
                let idv = variantTitle.split("/").map((x) => x.trim());
                idv[2] = idv[2]
                  .replace("Sentry Ultra Privacy Gate Lock", "For Glass/Privacy Gates (Ultra)")
                  .replace("Sentry Privacy Gate Lock", "For Glass/Privacy Gates")
                  .replace("Sentry Ultra Gate Lock", "For Regular Gates (Ultra)")
                  .replace("Sentry Gate Lock", "For Regular Gates");
                
                variantTitle = idv.join(" / ");
              }
            }

            return `
              <div class="cart-item ${bundledWith != null ? "bundled-item" : ""}" data-cart-id="${item.id}" data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" ${bundleId != null ? `data-bundle-id="${bundleId}"` : ""} data-qty="${item.quantity}" >
                <a href="${itemUrl}">
                  <img class="product-image" src="${itemImage}" alt="${productTitle}" width="" height="" draggable="false" />
                </a>
                <div class="cart-item-info">
                  <p class="product-title">${productTitle}</p>
                  <p class="product-type">${item.product_type}</p>
                  <p class="variant-title">${variantTitle}</p>
                  <div class="price-container">
                    <span class="price">${theme.Currency.formatMoney(item.final_price)}</span>
                    <span class="compare_at_price"></span>
                  </div>
                  ${
                    item.product_type == "Gift" || item.variant_id == "47364330750179"
                      ? ""
                      : `
                      <div class="qty-container">
                        <div class="qty-box">
                          <button class="qty-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                              <path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/>
                            </svg>
                          </button>
                          <input type="text" value="${item.quantity}" class="qty-input" />
                          <button class="qty-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                              <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    `
                  }
                </div>
                <div>
                  <button class="cart-remove">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                      <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                  </button>
                </div>
              </div>
            `;
          })
          .join("")}
        `;

      this.handleCartRemoveFunction();
      this.handleQuantityMinus();
      this.handleQuantityPlus();
      this.handleQuantityInput();
    } else {
      this.classList.add("empty-cart");
      cartSummary.innerHTML = `
        <p>Continue shopping. Your cart's feeling a little lonely.</p>
        `;
    }

    this.updateItemCount(item_count);
  }

  updateItemCount(item_count) {
    const cartQty = document.querySelectorAll(".cart-qty span");
    cartQty.forEach((x) => (x.innerHTML = item_count));
  }

  handleCartRemoveFunction() {
    const btns = this.querySelectorAll(".cart-remove");
    btns.forEach((btn) => {
      btn.addEventListener("click", async ({ currentTarget }) => {
        const cartItem = currentTarget.closest(".cart-item");
        const variantId = cartItem.dataset.variantId;
        const bundleId = cartItem.dataset.bundleId;

        if (!bundleId) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: variantId,
              quantity: 0,
            }),
          });
        } else {
          const bundleItems = this.querySelectorAll(
            `.cart-item[data-bundle-id="${bundleId}"]`,
          );
          const variantIds = [...bundleItems].map(
            (bundleItem) => bundleItem.dataset.variantId,
          );
          const updates = variantIds.reduce((acc, item) => {
            acc[item] = 0;
            return acc;
          }, {});
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        }
        this.updateCartPreview();
      });
    });
  }

  handleQuantityMinus() {
    const btns = this.querySelectorAll(".qty-minus");
    btns.forEach((btn) => {
      btn.addEventListener("click", async ({ currentTarget }) => {
        const cartItem = currentTarget.closest(".cart-item");
        const variantId = cartItem.dataset.variantId;
        const bundleId = cartItem.dataset.bundleId;

        const curQty = Number(cartItem.dataset.qty);

        if (!bundleId) {
          let updates = {
            [variantId]: curQty - 1,
          };

          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        } else {
          const bundleItems = this.querySelectorAll(
            `.cart-item[data-bundle-id="${bundleId}"]`,
          );
          const variantIds = [...bundleItems].map(
            (bundleItem) => bundleItem.dataset.variantId,
          );
          const updates = variantIds.reduce((acc, item) => {
            acc[item] = curQty - 1;
            return acc;
          }, {});
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        }

        this.updateCartPreview();
      });
    });
  }

  handleQuantityPlus() {
    const btns = this.querySelectorAll(".qty-plus");
    btns.forEach((btn) => {
      btn.addEventListener("click", async ({ currentTarget }) => {
        const cartItem = currentTarget.closest(".cart-item");
        const variantId = cartItem.dataset.variantId;
        const bundleId = cartItem.dataset.bundleId;

        const curQty = Number(cartItem.dataset.qty);

        if (!bundleId) {
          let updates = {
            [variantId]: curQty + 1,
          };

          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        } else {
          const bundleItems = this.querySelectorAll(
            `.cart-item[data-bundle-id="${bundleId}"]`,
          );
          const variantIds = [...bundleItems].map(
            (bundleItem) => bundleItem.dataset.variantId,
          );
          const updates = variantIds.reduce((acc, item) => {
            acc[item] = curQty + 1;
            return acc;
          }, {});
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        }

        this.updateCartPreview();
      });
    });
  }

  handleQuantityInput() {
    const inputs = this.querySelectorAll(".qty-input");
    inputs.forEach((input) => {
      input.addEventListener("change", async ({ currentTarget }) => {
        const cartItem = currentTarget.closest(".cart-item");
        const variantId = cartItem.dataset.variantId;
        const bundleId = cartItem.dataset.bundleId;

        const newQty = Number(currentTarget.value);

        if (!bundleId) {
          let updates = {
            [variantId]: newQty,
          };

          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        } else {
          const bundleItems = this.querySelectorAll(
            `.cart-item[data-bundle-id="${bundleId}"]`,
          );
          const variantIds = [...bundleItems].map(
            (bundleItem) => bundleItem.dataset.variantId,
          );
          const updates = variantIds.reduce((acc, item) => {
            acc[item] = newQty;
            return acc;
          }, {});
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          });
        }

        this.updateCartPreview();
      });
    });
  }
}

customElements.define("cart-preview", CartPreview);
